export function getView(thread_type) {
  return thread_type === 'in_app' ? 'InApp' : 'No'
}
